// Pure port of WindAlert-Web/App_Code/CoverPhotosManager.vb selection logic.
// DOM-free and unit-testable: takes the raw getCoverPhotos sheet values and
// returns the selected cover photo, or null when nothing can be selected
// (callers fall back to the brand's default_cover, as the legacy Try/Catch did).

const PHOTO_BASE_URL = 'https://cdn-consumer.weatherflow.com/brand-images/'

// Sheet column indexes (legacy BrandPhoto enum)
const COLUMN = {
  ENVIRONMENT: 0,
  BRAND: 1,
  WEIGHT: 2,
  TOP_IMAGE: 3,
  TOP_POSITION: 4,
  MID_IMAGE: 5,
  MID_POSITION: 6,
  LOGO_COLOR: 7,
  TAGLINE_COLOR: 8
}

const toCoverPhoto = (row, brandKey) => {
  return {
    top_photo: `${PHOTO_BASE_URL}${brandKey}/${row[COLUMN.TOP_IMAGE]}`,
    top_position: row[COLUMN.TOP_POSITION],
    mid_photo: `${PHOTO_BASE_URL}${brandKey}/${row[COLUMN.MID_IMAGE]}`,
    mid_position: row[COLUMN.MID_POSITION],
    // Legacy CoverPhotos.Brand getter: spaces become dashes (CSS class on #cover-photo-holder)
    brand_class: (row[COLUMN.BRAND] || '').replace(/ /g, '-'),
    logo_color: row[COLUMN.LOGO_COLOR],
    tagline_color: row[COLUMN.TAGLINE_COLOR]
  }
}

// Legacy BuildWeightedArray, arithmetic preserved: the inclusive VB loop
// (For x = startWeight To startWeight + weight) inserts weight + 1 entries
// per row, so a weight of 0 still gets one slot. Do not "fix" this — it
// would shift the observed photo distribution.
const buildWeightedArray = (rows) => {
  const weighted = []

  rows.forEach((row, rowIndex) => {
    const weight = parseInt(row[COLUMN.WEIGHT]) || 0

    for (let x = 0; x <= weight; x++) {
      weighted.push(rowIndex)
    }
  })

  return weighted
}

export const selectCoverPhoto = ({ sheetValues, brandKey, requestedBrand = null, isProduction = true }) => {
  if (!Array.isArray(sheetValues) || sheetValues.length < 2) return null

  // Drop the sheet header row
  const rows = sheetValues.slice(1)

  // Requested photo (/brand/{brand} route): matched on the brand name with
  // spaces removed, and — like legacy SelectRequestedCoverPhoto — NOT
  // filtered by environment, so staging rows can be previewed by name.
  if (requestedBrand) {
    const match = rows.find(
      (row) => (row[COLUMN.BRAND] || '').replace(/ /g, '') === requestedBrand
    )
    if (match) return toCoverPhoto(match, brandKey)
    // No match falls through to random selection, as legacy did.
  }

  // Random selection: production only sees production rows; dev shows all.
  const choices = isProduction
    ? rows.filter((row) => row[COLUMN.ENVIRONMENT] === 'production')
    : rows
  if (!choices.length) return null

  const weighted = buildWeightedArray(choices)
  const selectedIndex = weighted[Math.floor(Math.random() * weighted.length)]

  return toCoverPhoto(choices[selectedIndex], brandKey)
}
